/* eslint-disable */
$(function () {

  //  Horizontal section
  $('.tab-horizontal [role="tab"]').on('click', function () {
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');
    var panelTarget = $(this).parents('.tab-horizontal').find("[data-target='" + $(this).attr('data-link') + "']");

    panelTarget.siblings().removeClass('is-active');
    panelTarget.addClass('is-active');
  });
});
/* eslint-enable */
